import { render, staticRenderFns } from "./VaultFileItemWithPreview.vue?vue&type=template&id=754a1e50&scoped=true&"
import script from "./VaultFileItemWithPreview.vue?vue&type=script&lang=ts&"
export * from "./VaultFileItemWithPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VaultFileItemWithPreview.vue?vue&type=style&index=0&id=754a1e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a1e50",
  null
  
)

export default component.exports